const BUTTON_SIGN = [
    "Подробнее",
    "Course details"
]

export function executeLmsButtonPath(buttons: any) {
    const detailsButton = buttons?.find(
      // @ts-ignore
      (button) => {
        if (Array.isArray(button.text) || Array.isArray(button.textMobile)) {
            return (
                button.text?.some((t) => BUTTON_SIGN?.includes(t.name)) ||
                button.textMobile?.some((t) => BUTTON_SIGN?.includes(t.name))
            )
        }

        return (
            button.text === "Подробнее" ||
            button.textMobile === "Подробнее" ||
            button.text === "Course details" ||
            button.textMobile === "Course details"
        )
      }
    );
    return (detailsButton ? 
       ( typeof detailsButton?.href === 'string' ? 
        detailsButton.href : 
    detailsButton.href?.find((i) => i?.name !== '')?.name) : null);
}const BUTTON_SIGN = [
    "Подробнее",
    "Course details"
]

export function executeLmsButtonPath(buttons: any) {
    const detailsButton = buttons?.find(
      // @ts-ignore
      (button) => {
        if (Array.isArray(button.text) || Array.isArray(button.textMobile)) {
            return (
                button.text?.some((t) => BUTTON_SIGN?.includes(t.name)) ||
                button.textMobile?.some((t) => BUTTON_SIGN?.includes(t.name))
            )
        }

        return (
            button.text === "Подробнее" ||
            button.textMobile === "Подробнее" ||
            button.text === "Course details" ||
            button.textMobile === "Course details"
        )
      }
    );
    return (detailsButton ? 
       ( typeof detailsButton?.href === 'string' ? 
        detailsButton.href : 
    detailsButton.href?.find((i) => i?.name !== '')?.name) : null);
}